import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import { reviewData } from '../review-data';
import { buildReviewListSchema, type ReviewItem } from '../review-schema.util';
import type { ReviewVariantSchemaData } from '../star-reviews/star-reviews.schema';

const VARIANT_ID_FRAGMENT = 'reviews-columns';
const DEFAULT_LIST_NAME = 'Industry Endorsements';

/**
 * Returns Review nodes + an ItemList for the column-reviews variant. Reviews are
 * sourced from `reviewData[2]`. Each entry has a `description` (job title / context)
 * which we surface as the author's jobTitle when present.
 */
export function getColumnReviewsSchema(data: ReviewVariantSchemaData | null): SchemaOrgNode[] | null {
  if (!data) return null;
  const items: ReviewItem[] = reviewData[2];
  const nodes = buildReviewListSchema({
    listId: `${data.pageUrl}#${VARIANT_ID_FRAGMENT}`,
    listName: data.reviewTitle?.trim() || DEFAULT_LIST_NAME,
    siteUrl: data.siteUrl,
    organizationName: data.organizationName,
    items,
  });
  if (!nodes) return null;

  // column-reviews items include a `description` field — attach as author.jobTitle.
  return nodes.map((node) => {
    if (node['@type'] !== 'Review') return node;
    const match = node['@id']?.match(/-review-(\d+)$/);
    if (!match) return node;
    const description = items[Number.parseInt(match[1], 10) - 1]?.description;
    if (!description) return node;
    const author = node.author as { '@type': string; name: string };
    return { ...node, author: { ...author, jobTitle: description } };
  });
}
